// removed by extract-text-webpack-plugin
module.exports = {"page-loading":"page-loading__e78d313cbe4ab00ffaae7e7aa856ec8c","page-loading-box":"page-loading-box__2d304f809016b9a0d2c823bd39bedbf3","dot-wrap":"dot-wrap__787b7c509192160826a11f136aeb45fe","dot":"dot__e5f425a4439529953a2abd5444dd9f7e","wave":"wave__ce060f48d77bcc85197955fdc8aae7e6","retry":"retry__8579e9779dbe955f39a1852b4cc9307f"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/PageLoading/style.scss
// module id = 2397
// module chunks = 84